import { Journal, Publisher } from '@/module/Journal/model/JournalTypes';

import { AuthorRequest, IdentityRequest, PublishedAt, PublishedAtRequest } from '@/feature/utils';
import { Nomenclature } from '@feature/nomenclature';

export enum PublishedIn {
  JOURNAL = 'JOURNAL',
  PUBLISHER = 'PUBLISHER',
}

export const citationPrestigeList = [
  'ARTICLE_ISI',
  'ARTICLE_BDI',
  'PRESTIGIOUS_BOOK',
  'BOOK_BDI',
  'CHAPTER_BDI',
] as const;

export type CitationPrestige = (typeof citationPrestigeList)[number];

export interface CitationIdentifiers {
  wosId: string;
  doi: string;
  scopusId: string;
  formattedDoi: string;
  formattedWosId: string;
}

export interface CitationAuthor {
  id: number;
  orderNo: number;
  alias: string;
  userName: string;
  shortUserName: string;
  reclaimed: boolean;
  membership: {
    id: number;
    name: string;
  };
}

export interface Citation {
  id: number;
  publishedIn: PublishedIn;
  title: string;
  identifiers: CitationIdentifiers;
  journal: Journal;
  publisher: Publisher;
  authors: CitationAuthor[];

  noOfAuthors: number;

  citationPrestige: CitationPrestige;
  citationDate: PublishedAt;
  wosIndexes: Nomenclature[];
  wosCategories: Nomenclature[];
}

export interface CitationRequest {
  publishedIn: PublishedIn;
  title: string;
  identifiers: {
    wosId: string;
    doi: string;
    scopusId: string;
  };
  journal: IdentityRequest | null;
  publisher: IdentityRequest | null;
  authors: AuthorRequest[];

  noOfAuthors: number;
  citationPrestige: CitationPrestige;
  citationDate: PublishedAtRequest;
  wosIndexes: IdentityRequest[];
  wosCategories: IdentityRequest[];
}

export interface CitationFilters {
  publicationId: number;
}
